import "./App.css";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import AuthProvider from "./context/AuthProvider";
import CarCapture from "./components/carCapture";
import CarV2 from "./components/car-v2";
import Helper from "./extra/helper";
import Connect from "./components/error-page/not-connected";
function App() {
  const conect = window.navigator.onLine;
  // const version = Helper.getParamUrlByKey('version') === 'modern' ? true : false
  return (
    <BrowserRouter>
      <AuthProvider>
        <Switch>
          <Route component={conect ? CarV2 : Connect} path="/" />
        </Switch>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
